import { createUseStyles } from "react-jss";
import { SPACING } from "../../../constants/styleGuide";

/**
 *
 * @visibleName Organization Detail styles used in the component.
 */

const OrganizationDetailStyles = createUseStyles({
  leftContent: {
    padding: '30px 0px'
  },
  rightContent: {
    paddingRight: 15,
  },
  contentSpacing16: {
    padding: '15px 0px'
  },
  middleContent: {
    paddingRight: SPACING.s72,
  },
  pageContainer: {
    "& div": {
      backgroundColor: "#FFFFFF",
    },
  },
  editOrganization: {
    fontFamily: "Bogle",
    fontSize: "30px",
    fontWeight: "bold"
  },
  btnGroup: {
    justifyContent: "flex-end",
    paddingTop: "24px",
    paddingRight: "64px",
    paddingBottom: "40px",
  },
  orgField: {
    marginTop: "16px"
  },
  contentSpacing24: {
    paddingTop: SPACING.s40,
    paddingBottom: SPACING.s40,
  },
  contentPadding24: {
    paddingTop: SPACING.s40,
  },
  addressTypeField: {
    width: "40%",
  },
  addressLine1Field: {
    width: "80%",
  },
  firmEmailAddressField: {
    width: "50%",
  },
  width15per: {
    width: "15%",
  },
  width30per: {
    width: "30%",
  },
  width35per: {
    width: "35%",
  },
  width40per: {
    width: "40%",
  },
  paddingLeft: {
    paddingLeft: "20px",
  },
  parent: {
    width: "50%",
    display: "flex",
    justifyContent: "space-between"
  },
  parent1: {
    flex: 1,
    display: "flex",
  },
  accordionSection: {

  },
  accordianHeading: {
    fontSize: "26px",
    fontFamily: "Bogle",
    fontWeight: "bold",
    marginTop: "30px",
    display: "block",
    paddingTop: "30px",
    borderTop: "1px solid #ddd"
  },
  city: {
    paddingRight: "10px",
    "& input": {
      width: "180px"
    },
    "& div > div": {
      marginTop: "9px"
    }
  },
  state: {
    width: "180px",
  },
  country: {
    width: "200px",
    marginTop: "9px"
  },
  stateWrapper: {
    paddingRight: "10px",
  },
  countryWrapper: {
    width: "200px"
  },
  gridCoulmn: {
    paddingRight: '15px'
  },
  pageContainer: {
    "& > div": {
      backgroundColor: "#FFFFFF",
    },
    "& .MuiGrid-root > div": {
      backgroundColor: "#FFFFFF",
    },
    "& .MuiDataTable-root div": {
      backgroundColor: "transparent !important",
    },
    display: "flex",
    flexWrap: "wrap",
  },
});

export default OrganizationDetailStyles;
